@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --sidebar-width: 256px;
    --sidebar-collapsed: 64px;
    --header-height: 60px;
  }
  html { @apply h-full antialiased; }
  body { @apply h-full bg-slate-50 text-slate-900; }
  #root { @apply h-full; }
}

@layer components {
  .btn-primary {
    @apply inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 
           disabled:bg-blue-300 disabled:cursor-not-allowed text-white 
           font-medium px-4 py-2 rounded-lg text-sm transition-colors 
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2;
  }
  .btn-secondary {
    @apply inline-flex items-center gap-2 border border-slate-300 
           bg-white hover:bg-slate-50 text-slate-700 font-medium 
           px-4 py-2 rounded-lg text-sm transition-colors
           focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2;
  }
  .btn-danger {
    @apply inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 
           text-white font-medium px-4 py-2 rounded-lg text-sm transition-colors;
  }
  .form-input {
    @apply w-full border border-slate-300 rounded-lg px-3 py-2 text-sm
           bg-white text-slate-900 placeholder-slate-400
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
           disabled:bg-slate-50 disabled:text-slate-400 transition;
  }
  .form-input-error {
    @apply border-red-400 bg-red-50 focus:ring-red-400;
  }
  .form-select {
    @apply w-full border border-slate-300 rounded-lg px-3 py-2 text-sm
           bg-white text-slate-900
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
           disabled:bg-slate-50 transition cursor-pointer;
  }
  .card {
    @apply bg-white border border-slate-200 rounded-xl shadow-sm;
  }
  .card-header {
    @apply px-6 py-4 border-b border-slate-100;
  }
  .card-body {
    @apply p-6;
  }
  .page-title {
    @apply text-2xl font-bold text-slate-900;
  }
  .section-title {
    @apply text-lg font-semibold text-slate-800;
  }
  .label {
    @apply block text-sm font-medium text-slate-700 mb-1;
  }
  .helper-text {
    @apply text-xs text-slate-500 mt-1;
  }
  .error-text {
    @apply text-xs text-red-600 mt-1 flex items-center gap-1;
  }
  .skeleton {
    @apply bg-slate-200 rounded animate-pulse;
  }
  .badge {
    @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold;
  }
  .badge-success { @apply badge bg-emerald-100 text-emerald-800 border border-emerald-200; }
  .badge-danger  { @apply badge bg-red-100 text-red-800 border border-red-200; }
  .badge-warning { @apply badge bg-amber-100 text-amber-800 border border-amber-200; }
  .badge-info    { @apply badge bg-blue-100 text-blue-800 border border-blue-200; }
  .badge-neutral { @apply badge bg-slate-100 text-slate-700 border border-slate-200; }
  .table-container { @apply overflow-x-auto rounded-lg border border-slate-200; }
  .data-table { @apply w-full text-sm text-left; }
  .data-table thead { @apply bg-slate-50 text-slate-600 uppercase text-xs tracking-wider sticky top-0; }
  .data-table thead th { @apply px-4 py-3 font-semibold; }
  .data-table tbody tr { @apply border-t border-slate-100 hover:bg-slate-50 transition-colors; }
  .data-table tbody td { @apply px-4 py-3 text-slate-700; }
  .data-table tbody tr:nth-child(even) { @apply bg-slate-50/50; }
}

@layer utilities {
  .scrollbar-thin { scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent; }
  .scrollbar-thin::-webkit-scrollbar { width: 4px; height: 4px; }
  .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }
  .scrollbar-thin::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 99px; }
}
